import {Injectable} from '@angular/core';
import {ExtractConfigEntry} from "@app/_models/api";
import {TableOptionsService} from "@app/_services/table-options.service";

@Injectable({
    providedIn: 'root'
})
export class ExtractConfigService extends TableOptionsService<ExtractConfigEntry> {
    constructor() {
        super();
    }

    public override matches(element: ExtractConfigEntry, term: string) {
        const t = term.toLowerCase();
        return (
            element.extractKey?.toLowerCase().includes(t) ||
            element.name?.toLowerCase().includes(t) ||
            element.customerCode?.toLowerCase().includes(t) ||
            element.type?.toLowerCase().includes(t)
        );
    }
}
